import { Button, Column, DateColumn, Grid, LocalDateColumn, OriginalTimezoneDateColumn } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";

import { Rep } from "../../../../models";
import RepsApi, { RepsFilter } from "../../api/repsApi";

interface Props {
	filters: RepsFilter;
	setFilters: (filters: RepsFilter) => void;
}

const COLUMNS = [
	new Column("Rep Id", "repId"),
	new Column("Brand", "brand"),
	new Column("Channel", "channel"),
	new Column("Vendor", "vendor"),
	new Column("State", "state"),
	new Column("Office", "branchName"),
	new Column("Position", "position"),
	new Column("Agent Id", "login"),
	new Column("First Name", "firstName"),
	new Column("Middle Name", "middleName"),
	new Column("Last Name", "lastName"),
	new OriginalTimezoneDateColumn("Date Of Birth", "dateOfBirth").dateOnly(),
	new Column("Last Four SSN", "lastFourSSN"),
	new Column("Language", "language"),
	new Column("Phone Number", "phone"),
	new Column("Email", "email"),
	new OriginalTimezoneDateColumn("Start Date", "startDate").dateOnly(),
	new LocalDateColumn("Deactivation Date", "derivedDeactivationDate").dateOnly(),
	new Column("Active", "active").withBooleanFormat("Active", "Inactive"),
	new DateColumn("Last Sale", "dateLastSale"),
	new Column("Last Machine GPS Ping", "lastMachinePingName"),
	new LocalDateColumn("Last Machine GPS Ping Date", "lastMachinePingTimestamp"),
	new Column("Discipline", "lastDisciplineName"),
	new Column("Discipline Reason", "lastDisciplineReason"),
	new LocalDateColumn("Discipline Start Date", "lastDisciplineStartDate").dateOnly(),
	new LocalDateColumn("Discipline End Date", "lastDisciplineEndDate").dateOnly(),
	new Column("Default Utility", "defaultUtility"),
	new LocalDateColumn("Last Modified", "dateLastModified").dateOnly(),
	new Column("Last Modified By", "lastModifiedBy"),
	new Column("GPS", "id"),
] as Column<Rep>[];

export function RepsGrid(props: Props) {
	const repsQuery = useQuery({
		queryKey: ["reps", props.filters],
		queryFn: () =>
			RepsApi.getReps({
				...props.filters,
			}),
	});
	const history = useHistory();

	const handleRowClick = (repId: number) => {
		history.push(`/AgentPortal/${repId}`);
	};

	const columns = [
		new Column("Portal", "repId").withFormat((v) => <Button onClick={() => handleRowClick(v)}>Open</Button>),
		...COLUMNS,
	];

	return (
		<Grid<Rep>
			id="repsGrid"
			title="Representatives"
			keyProperty="id"
			sortable
			changeVisibility
			resizeable
			page
			totalItems={repsQuery.data?.totalItems ?? 0}
			currentPage={props.filters.currentPage}
			pageChanged={(value) => props.setFilters({ ...props.filters, currentPage: value })}
			values={repsQuery.data?.items ?? []}
			loading={repsQuery.isLoading}
			columns={columns}
			canSetItemsPerPage
			pageSize={props.filters.itemsPerPage}
			setItemsPerPage={(value) => {
				props.setFilters({ ...props.filters, itemsPerPage: value });
			}}
		/>
	);
}
